import React, {ReactElement} from "react";
import {useTranslation} from "react-i18next";

type ListOptionsProps = {
    table: {
        setPageSize: (pageSize: number) => void;
    };
    rowQuantity: number;
};

export function ListOptions({table, rowQuantity}: ListOptionsProps): ReactElement {
    const {t} = useTranslation();
    const positions: Array<number | string> = [10, 30, 50, 100, t('user-page.wzs.filters.all')];

    function changeRowOnPage(event: React.ChangeEvent<HTMLSelectElement>): void {
        const selectedValue = event.target.value;
        table.setPageSize(['10', '30', '50', '100'].includes(selectedValue) ? Number(selectedValue) : rowQuantity);
    }

    return (
        <div className="list-options">
            <div className="row-quantity">
                <span>{t('user-page.wzs.filters.show')}</span>
                <select defaultValue={10} onChange={changeRowOnPage}>
                    {positions.map((position) => <option value={position} key={position}>{position}</option>)}
                </select>
                <span>{t('user-page.wzs.filters.positions')}</span>
            </div>
        </div>
    );
}
